import CardWithTitle from 'components/CardWithTitle';
import { Title } from 'components/Typography';
import { Civility } from 'core/enums/civility';
import Female from 'images/icons/Female.svg';
import Male from 'images/icons/Male.svg';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSessionStore } from 'stores/session';
import { UserRole } from '../../core/enums/userRole';
import Candidate from '../../core/models/candidate';
import User from '../../core/models/user';
import CandidateLicenseView from './CandidateLicenseView';
import CandidateSubscriptionView from './CandidateSubscriptionView';
import DashboardTresholdsEditing from './DashboardTresholdsEditing';
import LicencesVisualisation from './LicencesVisualisation';
import { SAvatar, SRight, SWrapper } from './styles';
import UserInformationForm from './UserInformationForm';

const Profile: FC = () => {
    const { t } = useTranslation();
    const user = useSessionStore((s) => s.user) as User | Candidate | null;

    if (!user) {
        return null;
    }

    const displaySubscription = UserRole.Candidate === user.role && user.hasPaid;

    return (
        <>
            <Title text={t('page.profile.title')} />
            <SWrapper>
                <SAvatar alt="avatar" src={Civility.Female === user.civility ? Female : Male} />
                <SRight>
                    <CardWithTitle label={t('profile.account-information')}>
                        <UserInformationForm />
                    </CardWithTitle>
                    {UserRole.AgencyAdmin === user.role && (
                        <CardWithTitle label={t('agency.my-licences')}>
                            <LicencesVisualisation />
                        </CardWithTitle>
                    )}
                    {UserRole.Candidate === user.role && (
                        <div id="dashboardTresholds">
                            <CardWithTitle label={t('dashboard-treshold.title')}>
                                <DashboardTresholdsEditing />
                            </CardWithTitle>
                        </div>
                    )}
                        <div>
                            {displaySubscription ? (
                                <CardWithTitle label={t('profile.subscription.title')}>
                                    <CandidateSubscriptionView />
                                </CardWithTitle>
                            ) : (
                                <CardWithTitle label={t('profile.license.title')}>
                                    <CandidateLicenseView />
                                </CardWithTitle>
                            )}
                        </div>
                </SRight>
            </SWrapper>
        </>
    );
};

export default Profile;
